import React, { FC } from 'react';
import { createPortal } from 'react-dom';
import './style.less';

interface IProps {
	containerClass?: string;
	visible?: boolean;
	changeVisible?: (able: boolean) => void;
}
const DialogDetailContainer: FC<IProps> = (props) => {
	const { containerClass, visible, changeVisible } = props;
	if (typeof document === 'undefined') return <></>;

	// 弹窗显示禁止body滚动
	if (visible) {
		document.body.style.overflow = 'hidden';
	} else {
		document.body.style.removeProperty('overflow');
	}
	return createPortal(
		<>
			{visible ? (
				<div className={`dialog-detail-container ${containerClass}`}>
					<div className="main">
						<img
							onClick={() => changeVisible(false)}
							className="close-icon"
							src="https://img.qlchat.com/qlLive/activity/image/SD3VDMB6-2G95-S3CE-1709197714917-DWKXMBRCQR1X.png?x-oss-process=image/format,webp"
						/>
						{props?.children}
					</div>
				</div>
			) : null}
		</>,
		document.body,
	);
};
export default DialogDetailContainer;
